export type RetryOpts = {
  tries?: number;
  baseDelayMs?: number;
};

/**
 * Retry an async operation with exponential backoff.
 * Default: 3 tries, 200ms / 400ms / 800ms delays.
 */
export async function withRetry<T>(
  fn: () => Promise<T>,
  opts: RetryOpts = {},
): Promise<T> {
  const tries = opts.tries ?? 3;
  const base = opts.baseDelayMs ?? 200;
  let lastErr: unknown;
  for (let attempt = 0; attempt < tries; attempt++) {
    try {
      return await fn();
    } catch (err) {
      lastErr = err;
      if (attempt < tries - 1) {
        await new Promise((r) => setTimeout(r, base * 2 ** attempt));
      }
    }
  }
  throw lastErr;
}
